import { AbstractControl, UntypedFormGroup } from "@angular/forms";

import { DffFormControl, DffFormControlType } from "@dffedb/forms";

import { NoteBruger, NoteOpgavestyring, NoteOpgavestyringStatus } from "../model/note.model";

export class NoteOpgavestyringFormBuilder {
    public static opgavestyringToFormGroup(
        opgavestyring: NoteOpgavestyring,
        statusser: NoteOpgavestyringStatus[],
        brugere: NoteBruger[]
    ): UntypedFormGroup {
        const brugereListOptions = [{}, ...brugere];
        statusser = [{ key: null, value: "" }, ...statusser];

        const formGroup = new UntypedFormGroup({
            statusId: new DffFormControl(opgavestyring.statusId, {
                placeholder: "Status",
                controlType: DffFormControlType.DropdownList,
                dropdownListOptions: statusser
            }),
            opfoelgDato: new DffFormControl(opgavestyring.opfoelgDato, {
                placeholder: "Opfølgningsdato",
                controlType: DffFormControlType.DateInput
            }),
            opfoelgAf: new DffFormControl(opgavestyring.opfoelgAf, {
                placeholder: "Opfølger",
                controlType: DffFormControlType.DropdownList,
                dropdownListOptions: brugereListOptions
            }),
            udfoertDato: new DffFormControl(opgavestyring.udfoertDato, {
                placeholder: "Udførelsesdato",
                controlType: DffFormControlType.DateInput
            }),
            udfoertAf: new DffFormControl(opgavestyring.udfoertAf, {
                placeholder: "Udført af",
                controlType: DffFormControlType.DropdownList,
                dropdownListOptions: brugereListOptions
            })
        });

        this.valueChanges(formGroup);
        formGroup.valueChanges.subscribe(() => this.valueChanges(formGroup));

        return formGroup;
    }

    public static formGroupToOpgavestyring(group: UntypedFormGroup): NoteOpgavestyring {
        return {
            statusId: group.controls["statusId"].value,
            udfoertAf: group.controls["udfoertAf"].value,
            udfoertDato: group.controls["udfoertDato"].value,
            opfoelgAf: group.controls["opfoelgAf"].value,
            opfoelgDato: group.controls["opfoelgDato"].value
        };
    }

    private static valueChanges(formGroup: UntypedFormGroup): void {
        const erAfsluttet = formGroup.controls["statusId"].value === 30;
        if (erAfsluttet) {
            this.enable(formGroup.controls["udfoertDato"]);
            this.enable(formGroup.controls["udfoertAf"]);
        } else {
            this.disable(formGroup.controls["udfoertDato"]);
            this.disable(formGroup.controls["udfoertAf"]);
        }
    }

    private static disable(control: AbstractControl): void {
        if (control.enabled) {
            control.disable();
        }
    }

    private static enable(control: AbstractControl): void {
        if (control.disabled) {
            control.enable();
        }
    }
}
